import { useNavigate, useParams } from 'react-router-dom';
import { Formik, Form } from 'formik' 
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import Button from '../components/Button'
import { formatError, logError } from '../services/logging';
import PasswordInput from '../components/Forms/PasswordInput';
import PassConfirmInput from '../components/Forms/PassConfirmInput';
import { API_URL } from '../config/api';

const initialValues = {
    password: '',
    passwordConfirm: ''
};

const validationSchema = Yup.object({
    password: Yup.string()
        .min(8, "The password is too weak, it must contain at least 8 characters.")
        .required("Required"),
    passwordConfirm: Yup.string()
        .oneOf([Yup.ref('password')], 'Passwords must match')
        .required('Required')
});

const PasswordReset = () => {
    const { token } = useParams()
    const navigate = useNavigate()

    if (!token) {
        toast.error("Invalid password reset link.")
        navigate("/reset-password")
    }

  return (
    <main className="auth-container">
        <h2>Reset your password</h2>
        <p>Enter your new password below.</p>

        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting }) => {
                try {
                    const resp = await fetch(`${API_URL}/api/reset_password/${token}`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(values)
                    })

                    const data = await resp.json()
                    console.log("Password reset response:", data)

                    if (resp.ok) {
                        localStorage.removeItem("failedLoginAttempts")
                        toast.success("Password reset successfully. You can now log in with your new password.")
                        navigate('/login')
                    } else {
                        logError(data)
                        toast.error(data.message || "Password reset failed")
                    }
                } catch (error) {
                    logError(formatError(error))
                    toast.error("An unexpected error occurred. Please try again.")
                } finally {
                    setSubmitting(false)
                }
            }}
        >
            {({ errors, touched, dirty, isValid, isSubmitting }) => (
                <Form>
                    <PasswordInput errors={errors} touched={touched} />
                    <PassConfirmInput errors={errors} touched={touched} />

                    <Button 
                        variant="primary" 
                        text="Reset Password" 
                        type="submit" 
                        disabled={!dirty || !isValid || isSubmitting}
                    />
                </Form>
            )}
        </Formik>
    </main>
  )
}

export default PasswordReset